import React, { useState } from "react";
import {
  Modal,
  Box,
  CardContent,
  Typography,
  IconButton,
  TextField,
  Button,
  styled,
  FormControl,
  InputAdornment,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import LockIcon from "@mui/icons-material/Lock";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";

import axios from "axios";
import { API_BASE_URL } from "../../../apiConfig";
import { refreshTokenIfNeeded } from "../refreshTokenIfNeeded";
import { useNavigate } from "react-router-dom";

const StyledCard = styled(Box)(({ theme }) => ({
  backgroundColor: "#fff",
  borderRadius: "10px",
  boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
  padding: "20px",
  maxWidth: "600px",
  width: "77%", // عرض 50% من الشاشة
  margin: "auto",
}));

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "100%",
  maxWidth: 600,
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: 2,
  p: 4,
};

function AddUserModal({ onClose, onSubmit, error }) {
  const [userData, setUserData] = useState({
    userName: "",
    password: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUserData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async () => {
    if (!userData.userName || !userData.password) {
      alert("يرجى ملئ الحقول المطلوبة");
      return;
    }

    const token = localStorage.getItem("token");

    const newUser = {
      ...userData,
    };

    setIsLoading(true);
    try {
      const response = await axios.post(`${API_BASE_URL}User/AddNew`, newUser, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      });
      alert("تم اضافة المشرف بنجاح");
      onSubmit(); // استدعاء الدالة بعد الإضافة الناجحة
      onClose(); // إغلاق المودال
      setIsLoading(false);
    } catch (error) {
      if (error.response.status === 401) {
        const newToken = await refreshTokenIfNeeded();

        if (!newToken) {
          return navigate("/", { replace: true }); // if refresh expired
        }
        try {
          const response = await axios.post(
            `${API_BASE_URL}User/AddNew`,
            newUser,
            {
              headers: {
                "Content-Type": "multipart/form-data",
                Authorization: `Bearer ${newToken}`,
              },
            },
          );
          alert("تم اضافة المشرف بنجاح");
          onSubmit(); // استدعاء الدالة بعد الإضافة الناجحة
          onClose(); // إغلاق المودال
          setIsLoading(false);
        } catch (retryError) {
          alert("Retry failed:", retryError);
        }
      } else {
        alert("Error:", error);
      }

      setIsLoading(false);
    }
  };

  if (isLoading) {
    return (
      <div
        style={{
          background: "#272727",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "90vh",
        }}
      >
        <div
          style={{
            width: "40px",
            height: "40px",
            border: "4px solid #999",
            borderTop: "4px solid white",
            borderRadius: "50%",
            animation: "spin 1s linear infinite",
          }}
        ></div>

        <style>
          {`
            @keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
          `}
        </style>
      </div>
    );
  }

  return (
    <Modal
      dir="rtl"
      open={true}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <StyledCard>
          <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
            <AccountCircleIcon sx={{ fontSize: 80, color: "gray" }} />
          </Box>
          <IconButton
            onClick={onClose}
            sx={{ position: "absolute", top: 16, right: 16 }}
          >
            <CloseIcon />
          </IconButton>
          <CardContent sx={{ textAlign: "right", mt: 2 }}>
            {error && <Typography color="error">{error}</Typography>}
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginBottom: "3%",
                fontFamily: "'Changa', sans-serif",
              }}
            >
              <h3>إضافة مشرف جديد</h3>
            </div>

            {/* حقل اسم المشرف */}
            <FormControl fullWidth sx={{ marginBottom: 2 }}>
              <TextField
                placeholder="اسم المشرف"
                value={userData.userName}
                name="userName"
                onChange={handleChange}
                variant="outlined"
                sx={{
                  backgroundColor: "#fff",
                  borderRadius: "4px",
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#5b5b5c",
                  },
                  "&:hover .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#5b5b5c",
                  },
                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#0064b7",
                  },
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <AccountCircleIcon sx={{ color: "green" }} />
                    </InputAdornment>
                  ),
                }}
              />
            </FormControl>

            {/* حقل كلمة المرور */}
            <FormControl fullWidth sx={{ marginBottom: 2 }}>
              <TextField
                placeholder="كلمة المرور"
                type="password"
                value={userData.password}
                name="password"
                onChange={handleChange}
                variant="outlined"
                sx={{
                  backgroundColor: "#fff",
                  borderRadius: "4px",
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#5b5b5c",
                  },
                  "&:hover .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#5b5b5c",
                  },
                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#0064b7",
                  },
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <LockIcon sx={{ color: "#3c3c3c" }} />
                    </InputAdornment>
                  ),
                }}
              />
            </FormControl>

            <Box sx={{ textAlign: "center", mt: 4 }}>
              <Button
                variant="contained"
                color="primary"
                onClick={handleSubmit}
              >
                إضافة المشرف
              </Button>
            </Box>
          </CardContent>
        </StyledCard>
      </Box>
    </Modal>
  );
}

export default AddUserModal;
